<template>
  <div class="scrollbar-inner">
    <div class="card">
      <!-- Card header -->
      <div class="card-header">
        <!-- Title -->
        <h4 class="h3 mb-0 title">Timesheet Entry</h4>
      </div>
      <!-- Card body -->
      <!-- <div class="card-body">
        <div class="progress-label mb-3">
          <span
            class="bg-info text-white text-capitalize px-2"
            data-toggle="tooltip"
            data-placement="top"
            title
            data-original-title="5 out of 10 hours quoted on this Task"
          >5/10</span>
          <span
            class="badge bg-white text-default px-1 badge--font-size-per-76 text-lowercase font-weight-normal"
          >hours</span>
        </div>
        <div class="progress-label mb-3">
          <span
            class="bg-default text-white text-capitalize px-2"
            data-toggle="tooltip"
            data-placement="top"
            title
            data-original-title="Project is 15 hours over quote"
          >120/105</span>
          <span
            class="badge bg-white text-default px-1 badge--font-size-per-76 text-lowercase font-weight-normal"
          >hours</span>
        </div>
        <div class="progress-label mb-3">
          <span
            class="bg-secondary text-capitalize px-2"
            data-toggle="tooltip"
            data-placement="top"
            title
            data-original-title="17 hours ($170) per hour = $17,000"
          >$1.7k</span>
          <span
            class="badge bg-white text-default px-1 badge--font-size-per-76 text-lowercase font-weight-normal"
          >
            quoted
            on this Task
          </span>
        </div>
        <div class="progress-label mb-0">
          <span
            class="bg-danger text-white text-capitalize px-2"
            data-toggle="tooltip"
            data-placement="top"
            title
            data-original-title="Due Date"
          >30th January 2019</span>
          <span
            class="badge bg-white text-default px-1 badge--font-size-per-76 text-lowercase font-weight-normal"
          >deadline</span>
        </div>
      </div>-->
      <!-- <div class="card-body card-body border border-bottom-0 border-right-0 border-left-0">
        <form action>
          <div class="form-group mb-3">
            <label
              class="form-control-label text-muted font-weight-normal mb-3"
              for="exampleFormControlTextarea1"
            >
              Description
              of work completed, be
              short but accurate.
            </label>
            <label class="form-control-label mb-0" for="exampleFormControlTextarea1">
              You may like to extend this
              quote
            </label>
          </div>
          <button
            type="button"
            class="btn btn-primary btn-sm"
            data-target="offcanvasChangerequest"
            data-offcanvasfrom="offcanvas"
          >Change Request</button>
        </form>
      </div>-->

      <div class="card-body border border-bottom-0 border-right-0 border-left-0 timer-block">
        <!-- <div class="timer-block__add">
          <a href="#!" class="btn btn-sm btn-info">Add Time</a>
          <a href="#!" class="btn btn-sm btn-outline-primary">Add 10</a>
          <a href="#!" class="btn btn-sm btn-outline-primary">Add 30</a>
          <a href="timesheet.html" class="btn btn-sm btn-warning float-right">My Timesheet</a>
          <div class="btn-group btn-group-sm" role="group" aria-label="Basic example">
            <button type="button" class="btn btn-primary">Add 10</button>
            <button type="button" class="btn btn-primary">Add 30</button>
            <button type="button" class="btn btn-primary">Add Time</button>
          </div>
        </div>-->
        <div class="timer-block__timer">
          <form action>
            <div class="row align-items-center">
              <div class="col">
                <div class="form-group mb-3">
                  <label class="form-control-label" for="example-time-input-start">Start Time:</label>
                  <input
                    class="form-control form-control-sm"
                    type="time"
                    value="08:30:00"
                    id="example-time-input-start"
                  />
                </div>
              </div>
              <div class="col">
                <div class="form-group mb-3">
                  <label class="form-control-label" for="example-time-input-end">End Time:</label>
                  <input
                    class="form-control form-control-sm"
                    type="time"
                    value="11:30:00"
                    id="example-time-input-end"
                  />
                </div>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col">
                <div class="form-group mb-1">
                  <label class="form-control-label" for="example-number-input-hours">Hours:</label>
                  <!-- <input class="form-control form-control-sm" type="number" value="23" id="example-number-input-hours"> -->
                  <select class="form-control form-control-sm" id="exampleFormControlSelect1">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                    <option>10</option>
                    <option>11</option>
                    <option>12</option>
                    <option>13</option>
                    <option>14</option>
                    <option>15</option>
                    <option>16</option>
                    <option>17</option>
                    <option>18</option>
                    <option>19</option>
                    <option>20</option>
                    <option>21</option>
                    <option>22</option>
                    <option>23</option>
                    <option>24</option>
                  </select>
                </div>
              </div>
              <div class="col">
                <div class="form-group mb-1">
                  <label class="form-control-label" for="example-number-input-hours">Minutes:</label>
                  <input
                    class="form-control form-control-sm"
                    type="number"
                    value="23"
                    id="example-number-input-hours"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group mt-3">
                  <label class="form-control-label mb-3" for="exampleFormControlTextarea1">
                    Work completed on this
                    task
                  </label>
                  <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                </div>
                <button type="button" class="btn btn-success btn-lg btn-block">Submit</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TimesheetEntry",
  data() {
    return {};
  }
};
</script>

<style lang="sass">

</style>